<script setup lang="ts">
const STATS = [
  { value: "100+", lines: ["Trained IT", "Professionals"] },
  { value: "5x", lines: ["Faster Assembly", "Velocity"] },
  { value: "60+", lines: ["Frontend, AI Devs,", "DevOps, Testers"] },
  { value: "10+", lines: ["Agencies hired", " from us"] },
  { value: "85%", lines: ["productivity", "gain"] },
];
</script>

<template>
  <div class="relative">
    <div class="relative mx-auto max-w-5xl overflow-hidden rounded-2xl">
      <!-- 1px dividers between the boxes -->
      <div class="grid flex-1 grid-cols-1 gap-px sm:grid-cols-2 lg:grid-cols-5 bg-[#e5e5f4]  dark:bg-white/10">
        <div
          v-for="s in STATS"
          :key="s.value"
          class="flex flex-col items-center justify-center bg-[linear-gradient(118.11deg,#ffffff_4.47%,#faf5ff_79.8%)] px-3 py-6 text-center lg:aspect-video dark:bg-[linear-gradient(118.11deg,#0D0D42_4.47%,#060B28_79.8%)] max-h-52"
        >
          <p
            class="text-4xl font-black text-[#1E1B4B] sm:text-5xl dark:text-white"
          >
            {{ s.value }}
          </p>
          <p
            class="mt-3 text-xs capitalize font-semibold leading-relaxed tracking-[0.18em] text-[#5A5478] dark:text-white/60"
          >
            <template v-for="(line, i) in s.lines" :key="i">
              {{ line }}<template v-if="i < s.lines.length - 1"><br /></template>
            </template>
          </p>
        </div>
      </div>
    
    </div>
  </div>
</template>
